import {WebClient} from "../../store/clients/client";
import {Testimonial} from "../../models/site";
import {PublicWebClient} from "../../store/clients/public";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminFetchTestimonialsPaginated(page:number) {
    try {
        const response = await WebClient.AdminGetTestimonialPaginated(page);

        if (response.status === 200) {
            return response.data['results'] as Testimonial[]
        }
    }catch (e) {}

    return [] as Testimonial[];
}

export async function adminFetchTestimonial(testimonial:Testimonial) : Promise<Testimonial> {
    try {
        const response = await WebClient.AdminGetTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}

export async function adminUpdateTestimonial(testimonial:Testimonial) : Promise<Testimonial> {
    try {
        const response = await WebClient.AdminApproveTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}

export async function adminDeleteTestimonial(testimonial:Testimonial) : Promise<boolean> {
    try {
        const response = await WebClient.AdminDeleteTestimonial(testimonial);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}


// ---------------------------------------- USER ----------------------------------------
export async function newTestimonial(testimonial:Testimonial|any) : Promise<Testimonial> {
    try {
        const response = await WebClient.UserNewTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}

export async function fetchTestimonialsPaginated(page:number) {
    try {
        const response = await WebClient.UserGetTestimonialPaginated(page);

        if (response.status === 200) {
            return response.data['results'] as Testimonial[]
        }
    }catch (e) {}

    return [] as Testimonial[];
}

export async function fetchTestimonial(testimonial:Testimonial) : Promise<Testimonial> {
    try {
        const response = await WebClient.UserGetTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}

export async function userUpdateTestimonial(testimonial:Testimonial) : Promise<Testimonial> {
    try {
        const response = await WebClient.UserUpdateTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}

export async function deleteTestimonial(testimonial:Testimonial) : Promise<boolean> {
    try {
        const response = await WebClient.UserDeleteTestimonial(testimonial);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}

// ---------------------------------------- PUBLIC ----------------------------------------
export async function publicFetchTestimonialsPaginated(page:number) {
    try {
        const response = await PublicWebClient.GetPublicTestimonialsPaginated(page);

        if (response.status === 200) {
            return response.data['results'] as Testimonial[]
        }
    }catch (e) {}

    return [] as Testimonial[];
}

export async function publicFetchTestimonial(testimonial:Testimonial) : Promise<Testimonial> {
    try {
        const response = await PublicWebClient.GetPublicTestimonial(testimonial);

        if (response.status === 200) {
            return response.data as Testimonial
        }
    }catch (e) {}

    return {} as Testimonial;
}
